import { requestJson } from '@/api/httpClient'

export type LeadPayload = {
  source?: string
  name?: string
  company?: string
  email?: string
  phone?: string
  goal?: string
  message?: string
  pageUrl?: string
  userAgent?: string
  website?: string
}

export type LeadApiResponse = {
  ok?: boolean
  message?: string
}

export async function submitLeadApi(payload: LeadPayload): Promise<LeadApiResponse> {
  return requestJson<LeadApiResponse>('/api/lead', {
    method: 'POST',
    body: payload,
    cache: 'no-store',
    timeoutMs: 15000,
  })
}
